/**
 * 加载图片
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React from "react";
import { LoadingOutlined } from "@/utils/antdIcon";
import "./index.less";
import CircleProgress from "@/components/CircleProgress";
import {
  dealImageWidthHeight2,
  getMessageFileName,
  getImgSrc,
  getThumbUrl,
  downloadMessageFile,
  pushAutoDownload,
  getFileUrl
} from "@/utils/chat/index";
import { WithTranslation, withTranslation } from "react-i18next";
import { FileStatus, ImageChatMessage, MessageStatus } from "@/types/chat";

import { detectOS, FocusSDK, isFocusEnv } from "@/utils";
import ImService from "@/server/ImService";
import { nyrsfENStr } from "@/utils/date";
import {
  getPreviewImageModal,
  checkFileIsExpired,
  getDownloadFileRes
} from "../../utils/commonMessageModal";
import { message as toast } from "antd";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import { changeEgovUrl } from "@/utils/tools";
import imgLoading from "@/assets/img/img-loading.png";
import { DownloadOption, SaveOption } from "@/utils/DownloadFileQueue";
import { checkImgExists, getFileDownloadBzOptions } from "@/utils/chat/message";
import { MessageSendType } from "@/types/chat/enum";
import errImg from "@/assets/img/empty/err-img1.png";
import expiredImg from "@/assets/img/empty/expired-img.png";
import { addXtoken } from "@/utils/addToken";
import { isGifImage } from "../../utils/image";
import debounce from "lodash/debounce";
import GlobalContext from "@/context/GlobalContext";
import i18n from "@/i18n";
interface ImagePreviewProps {
  sendType: MessageSendType;
  message: ImageChatMessage;
  isUpload: boolean;
  uploadProgress: number;
  file?: Blob;
  onComplete: Function;
  onFailed: Function;
  isMergeForward?: boolean;
  isInviteForward?: boolean;
  modalMessages?: any[];
  updateSessionMessageMid: Function;
  status?: FileStatus;
  updateSessionMessagesTimestamp: Function;
  noSupportPre?: boolean;
  noPreAndNext?: boolean;
}

type IImagePreviewProps = Readonly<ImagePreviewProps & WithTranslation & ChatState>;

interface MessageOperateState {
  width: number;
  height: number;
  thumbWidth: number;
  progress: number;
  display: string;
  imgSrc: string;
  thumbUrl: string;
  viewModal: boolean;
  modalLoading: boolean;
  isDragging: Boolean;
  path: string;
  dataUrl: any;
  isShow: boolean;
  isError: boolean;
  loading: boolean;
  isExpired: boolean;
}
class ImagePreview extends React.Component<IImagePreviewProps, MessageOperateState> {
  static contextType = GlobalContext;
  imageRef: React.RefObject<HTMLImageElement> = React.createRef();
  preImageRef: React.RefObject<HTMLImageElement> = React.createRef();
  thumbWidth = 600;
  thumbHeight = 400;
  fileExpiredTime = 0;
  expiredAppKey = "";
  constructor(props: IImagePreviewProps) {
    super(props);
    const { width: imageWidth, height: imageHeight, url } = props.message;
    const [width, height] = dealImageWidthHeight2([imageWidth || 350, imageHeight || 180]);
    let thumbWidth = imageWidth || 100;
    if (!(imageWidth && imageWidth < 200 && imageHeight && imageHeight < 200)) {
      thumbWidth = this.thumbWidth;
    }
    this.state = {
      width: width,
      height: height,
      thumbWidth: thumbWidth,
      progress: 0,
      display: "none",
      imgSrc: "",
      thumbUrl: "",
      viewModal: false,
      modalLoading: true,
      isDragging: false,
      isShow: true,
      path: "",
      dataUrl: "",
      isError: props.message.statusType === MessageStatus.EXPIRED,
      loading: props.message.statusType !== MessageStatus.EXPIRED,
      isExpired: props.message.statusType === MessageStatus.EXPIRED
    };
  }
  public componentDidMount() {
    const {
      message,
      currentEmployee,
      sessionMessageMap,
      messageUploadStateMap,
      selectedSession,
      sendType
    } = this.props;
    const { appRuntimeEnv } = this.context;
    const {
      im,
      fileService: { imAppKey }
    } = appRuntimeEnv;
    this.fileExpiredTime = im.fileExpiredTime;
    this.expiredAppKey = imAppKey;
    let tempImageUrl: any;
    let MessageMap = sessionMessageMap[selectedSession.sessionId];
    MessageMap?.forEach((item) => {
      if (message.id === item.id) {
        tempImageUrl = messageUploadStateMap[item.id];
      }
      if (!tempImageUrl) return;
    });
    if (message.url) {
      const imgSrc = getImgSrc(message.url, FocusSDK.authInfo?.accessToken);
      let thumbUrl = "";
      // 小于100 * 100的图 直接显示原图
      if (message.width && message.width < 200 && message.height && message.height < 200) {
        thumbUrl = getThumbUrl(this.props.message.url, 100, 100);
      } else {
        thumbUrl = getThumbUrl(this.props.message.url, this.thumbWidth, this.thumbHeight);
      }
      if (
        (message as any).fileType?.includes("image/gif") ||
        isGifImage(message.url) ||
        detectOS() === "Mac"
      ) {
        thumbUrl = imgSrc;
      }
      thumbUrl = addXtoken(thumbUrl, FocusSDK.authInfo?.accessToken);
      const downLocalPath = message.downLocalPath;
      // console.log('downLocalPath', downLocalPath);
      if (isFocusEnv() && downLocalPath) {
        FocusSDK.checkLocalPathExist(downLocalPath, (exists: boolean) => {
          if (exists) {
            this.setState({ path: downLocalPath });
          } else {
            this.setState({ path: "" });
          }
        });
      }
      if (
        selectedSession?.isSecret &&
        message?.expire &&
        !message.readTimeOfMessage &&
        sendType === MessageSendType.OTHER
      ) {
        this.setState({ isShow: false });
      }
      if (!selectedSession?.isSecret) {
        pushAutoDownload(message, currentEmployee, this.doDownloadMessageFile);
      }
      const imgUrl = tempImageUrl?.message.url ? tempImageUrl?.message.url : thumbUrl;
      this.setState({
        display: "block",
        imgSrc: imgSrc,
        thumbUrl: thumbUrl,
        dataUrl: imgUrl
      });
      // FocusSDK.sendTrackLog({
      //   type: "LOADTHUM",
      //   data: {
      //     sta_ts: new Date().getTime(),
      //     id: message.id,
      //     url: imgUrl,
      //     f_s: message.size
      //   }
      // });
      // checkImgExists(tempImageUrl?.message.url ? tempImageUrl?.message.url : thumbUrl)
      //   .then((res) => {
      //     this.setState({
      //       newImgSrc: true
      //     });
      //   })
      //   .catch(() => {
      //     this.setState({
      //       newImgSrc: false
      //     });
      //   });
    } else if (this.props.file) {
      // 此逻辑未走到
      this.preViewLocalImage(this.props.file).catch(() => {
        this.setDefaultSrc();
      });
      return;
    }
  }
  shouldComponentUpdate(
    nextProps: IImagePreviewProps,
    nextState: MessageOperateState,
    nextContext: any
  ): boolean {
    const { message, status } = this.props;
    const { message: newMessage, status: newStatus } = nextProps;
    // if (
    //   newMessage.statusType === MessageStatus.EXPIRED &&
    //   message.statusType !== MessageStatus.EXPIRED
    // ) {
    //   return true;
    // }
    if (status === FileStatus.COMPLETED && newStatus === status) {
      return false;
    }
    if (message?.url?.includes("base64") && !newMessage?.url?.includes("base64")) {
      return false;
    }
    return true;
  }

  // 以下方法未用到
  setDefaultSrc = () => {
    const imgRef = this.imageRef.current as any;
    if (imgRef) {
      imgRef.src = "";
    }
    this.props.onFailed();
  };

  // 以下方法未用到
  preViewLocalImage = (file: Blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const imgRef = this.imageRef.current as any;
        if (evt.target?.result && imgRef) {
          imgRef.src = evt.target.result;
          if (!this.state.imgSrc) {
            this.setState({ imgSrc: imgRef.src });
          }
          this.props.onComplete();
          resolve();
        } else {
          reject(new Error(this.props.t("failed-to-load-picture")));
        }
      };
      reader.onerror = (error) => {
        reject(error);
      };
      if (file instanceof Blob) {
        reader.readAsDataURL(file);
      }
    }).then(() => {
      this.setState({ display: "block" });
    });
  };

  loadImageProgressCallback = (progress: number) => {
    this.setState({ progress });
  };

  getDownloadOptions = ({ viewFile, saveAs, message, auto }: SaveOption): DownloadOption => {
    const { t, updateSessionMessageMid } = this.props;
    return {
      onStarted: () => { },
      onProgress: () => { },
      onCancel: () => { },
      onPause: () => { },
      onResume: () => { },
      onFinish: async (file: { path: string; filename: string }, data: any) => {
        // 当多个文件同时下载时，file.path 获取路径错误
        const path = file.path;
        const imService = ImService.getInstance();
        const result = await imService.updateLocalPath(message.sessionId, message.mid, {
          downLocalPath: path
        });
        if (result) {
          updateSessionMessageMid({
            sessionId: (message as ImageChatMessage).sessionId,
            sendResult: { body: { ...message, downLocalPath: path } }
          });
          this.setState({
            path: path,
            isDragging: false
          });
        } else {
          if (!auto) {
            toast.error(t("failed"));
          }
          this.setState({ isDragging: false });
        }
      }
    };
  };

  doDownloadMessageFile = ({
    viewFile,
    saveAs,
    message,
    auto = false
  }: SaveOption): Promise<void> => {
    const options = this.getDownloadOptions({
      viewFile,
      saveAs,
      message,
      auto
    });
    return downloadMessageFile({ viewFile, saveAs, message, auto }, options);
  };

  previewImage = async () => {
    const { isShow, isExpired: expiredImg, isError } = this.state;
    const {
      message,
      isMergeForward,
      modalMessages,
      updateSessionMessageMid,
      noSupportPre,
      noPreAndNext,
      isInviteForward
    } = this.props;
    if (noSupportPre) {
      return;
    }
    if (expiredImg) {
      toast.error(i18n.t("chat:image-expired-tip"));
      return;
    }
    if (!message.localSendTimestamp || isError) {
      const url = getFileUrl(message.url, getFileDownloadBzOptions(message));
      const resJSON = await getDownloadFileRes(url);
      if (resJSON.response?.indexOf("1017005") > -1) {
        toast.error(i18n.t("chat:image-expired-tip"));
        const imService = ImService.getInstance();
        imService.updateMessage(message.sessionId, message.mid, {
          statusType: MessageStatus.EXPIRED
        });
        updateSessionMessageMid({
          sessionId: message.sessionId,
          sendResult: { body: { ...message, statusType: MessageStatus.EXPIRED } }
        });
        this.setState({
          isExpired: true,
          isError: true
        });
        this.forceUpdate();
        return;
      }
    }
    const isExpired = checkFileIsExpired({
      expiredAppKey: this.expiredAppKey,
      message,
      updateSessionMessageMid,
      type: "image",
      expiredTime: this.fileExpiredTime
    });
    if (isExpired) {
      this.setState({
        isExpired: true,
        isError: true
      });
      this.forceUpdate();
      return;
    }
    !isShow && this.handleSetReadTime();
    this.setState({ isShow: true });
    FocusSDK.printLog("预览图片webapp：click image");
    getPreviewImageModal({
      message,
      isMergeForward,
      isInviteForward,
      modalMessages,
      noPreAndNext: noPreAndNext
    });
  };

  handleSetReadTime = async () => {
    const { message, updateSessionMessageMid, updateSessionMessagesTimestamp } = this.props;
    const readTimeOfMessage = new Date().getTime();
    const imService = ImService.getInstance();
    const result = await imService.updateReadTime(message.sessionId, message.mid, {
      ...message,
      readTimeOfMessage
    });
    if (result) {
      await updateSessionMessageMid({
        sessionId: message.sessionId,
        sendResult: {
          body: { ...message, readTimeOfMessage }
        }
      });
      await updateSessionMessagesTimestamp({
        timestamp: new Date().getTime()
      });
    }
  };

  getFileName = () => {
    const message = this.props.message as any;
    const name = getMessageFileName(message);
    if (name) {
      return name;
    }
    return `${(window as any)?._BTS_CONFIG?.REACT_APP_NAME || process.env.REACT_APP_NAME}_${nyrsfENStr(new Date().getTime())}.jpg`;
  };

  onImageLoad = (e: any) => {
    const img = e?.currentTarget;
    const message = this.props.message as any;
    this.setState({ modalLoading: false });
    // FocusSDK.sendTrackLog({
    //   type: "LOADTHUM",
    //   data: {
    //     end_ts: new Date().getTime(),
    //     id: message.id,
    //     w_h: `${img?.width || ""}_${img?.height || ""}`
    //   }
    // });
  };

  onDragStart = (e: any) => {
    if (!isFocusEnv()) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    const { connectState, message, t } = this.props;
    if (connectState && connectState.state === ConnectState.READY) {
      const { path, isDragging } = this.state;
      // console.log('new message', message, '哈哈哈', path);
      if (isDragging) {
        toast.warning(t("file-downloading-drag-save"));
        return;
      }
      if (!path) {
        this.setState({ isDragging: true });
        toast.warning(t("file-downloading-drag-save"));
        this.doDownloadMessageFile({
          viewFile: false,
          saveAs: false,
          message
        }).then();
      } else {
        FocusSDK.checkLocalPathExist(path, (exists: boolean) => {
          if (exists) {
            FocusSDK.startDrag(path);
          } else {
            if (isDragging) {
              toast.warning(t("file-downloading-drag-save"));
              return;
            }
            this.setState({ isDragging: true });
            toast.warning(t("file-downloading-drag-save"));
            this.doDownloadMessageFile({
              viewFile: false,
              saveAs: false,
              message
            }).then();
          }
        });
      }
    } else {
      toast.warning(t("drag-after-the-network-is-normal"));
      return;
    }
  };

  onImgExpired = async () => {
    const { message, updateSessionMessageMid } = this.props;
    if (message.statusType !== MessageStatus.EXPIRED) {
      const isExpired = checkFileIsExpired({
        expiredAppKey: this.expiredAppKey,
        message,
        updateSessionMessageMid,
        type: "image",
        expiredTime: this.fileExpiredTime,
        noToast: true
      });
      if (isExpired) {
        this.setState({
          isExpired: true,
          isError: true
        });
        return;
      }
    }
  };

  public render() {
    const { width, height, dataUrl, isShow, loading, isError, isExpired } = this.state;
    const { message, isMergeForward, status, selectedSession } = this.props;
    const isDrag =
      FocusSDK.getDeviceInfo().platform !== "web" && !isMergeForward && !selectedSession?.isSecret;
    // console.log('是正则', message);
    const isLoading = loading && !dataUrl.includes("base64");
    return (
      <div
        className={`pre-view-box ${!isShow ? "filter-blur" : ""}`}
        style={{
          width: !isLoading && !isError ? width : "auto",
          height: "auto"
        }}
      >
        {!isShow && (
          <div className="image-message-mask" onClick={debounce(this.previewImage, 500)}>
            <div className="image-message-mask_btn">点击查看</div>
          </div>
        )}
        {isLoading && (
          <div className="preview-img-loading">
            <img ref={this.imageRef} src={imgLoading} draggable={false} />
          </div>
        )}
        <img
          id="img"
          ref={this.imageRef}
          src={changeEgovUrl(dataUrl)}
          onLoad={(e) => {
            this.onImageLoad(e);
            this.setState({ loading: false });
          }}
          onClick={debounce(this.previewImage, 500)}
          width={width}
          height={height}
          style={{
            display:
              isLoading || isError || message.statusType === MessageStatus.EXPIRED
                ? "none"
                : "block"
          }}
          data-id={message.id}
          draggable={isDrag}
          onDragStart={this.onDragStart}
          onError={() => {
            this.onImgExpired();
            this.setState({ isError: true, loading: false });
          }}
        />
        {(isError || message.statusType === MessageStatus.EXPIRED) && (
          <div className="errimg" onClick={debounce(this.previewImage, 500)}>
            <img
              ref={this.imageRef}
              src={isExpired || message.statusType === MessageStatus.EXPIRED ? expiredImg : errImg}
              width={101}
              height={75}
              draggable={false}
            />
          </div>
        )}
        {(status === FileStatus.UPLOADING || status === FileStatus.CANCELED) && (
          <div className="file-image-mask">
            <img className="imgLoading" src={imgLoading} alt="" />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps({ chat }: any) {
  const {
    connectState,
    currentEmployee,
    selectedSession,
    messageUploadStateMap,
    sessionMessageMap
  } = chat as ChatState;
  return {
    connectState,
    currentEmployee,
    selectedSession,
    messageUploadStateMap,
    sessionMessageMap
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      return dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    updateSessionMessagesTimestamp(data: { timestamp: number }) {
      dispatch({ type: "chat/updateSessionMessagesTimestamp", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation("chat")(ImagePreview));
